<template>
  <div>
    <div class="performance-card__meter-container">
      <div class="performance-card__meter">
        <span class="performance-card__meter-inner"></span>
      </div>
    </div>
    <div class="performance-card__inner--error">
      <div v-if="error">
        <div>Unable to receive data</div>
        <div>Refresh or try again in a few minutes</div>
      </div>
      <div v-else>
        <div>No Data</div>
      </div>
    </div>
  </div>
</template>

<script>

import CardItemMeter from '../CardItemMeter/CardItemMeter'

export default {
  props: {
    error: {
      type: Boolean
    } 
  },
  components: {
    CardItemMeter
  }
}
</script>

<style scoped>
  .performance-card__inner--error {
    width: 100%;
    height: 44px;
    margin: 16px auto;
    font-size: 16px;
    line-height: 140%;
    text-align: center;
    color: #778699;
  }
</style>
